import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { injectQueryClient } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { environment } from '#environments/environment';

export interface Country {
  countryCode: string;
  countryCommonLabel: string;
}

export interface TradeSector {
  tradeSectorLabel: string;
}

@Injectable({
  providedIn: 'root',
})
export default class DataRefService {
  private readonly httpClient = inject(HttpClient);
  private readonly translateService = inject(TranslateService);
  private readonly queryClient = injectQueryClient();

  getCountries() {
    return lastValueFrom(
      this.httpClient.get<Country[]>(`${environment.apiUrl}/v1/countries?sort=countryCommonLabel`, {
        headers: { 'Accept-Language': this.translateService.currentLang },
      }),
    );
  }

  getCountriesWithCache() {
    return this.queryClient.fetchQuery<Country[]>({ queryKey: ['countries', this.translateService.currentLang] });
  }

  getTradeSector(tradeSectorCode: string) {
    return lastValueFrom(
      this.httpClient.get<TradeSector>(`${environment.apiUrl}/v1/tradeSectors/NACE2/${tradeSectorCode}`),
    );
  }
}
